export default {"src":"/_next/static/media/ic_login_apple.662f8278.svg","height":36,"width":30,"blurWidth":0,"blurHeight":0};